"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const { version } = { "version": "0.4.0-rc.1" };
exports.default = version;
//# sourceMappingURL=version.js.map